module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Savage-Kingdom-S3.3ebeb89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Savage-Kingdom-S3.jpg
// module id = 0cyR
// module chunks = 0